import { Message } from "element-plus"
import axios from 'axios'
import qs from 'qs'
import path from '@/store/paths'
import fetch from '@/utils/IDC/fetch'


/**
 * http之get请求 (该方法已挂载Vue对象上，不必引入额外资源，直接通过this.$get(url,params,headersObj)的方式即可调用)
 * @param url (String类型，参数必填)
 * @param params (Object类型，参数可选)
 * @param headersObj (Object类型，有且有唯一键headers，例如：{headers：{"Accept": "application/json"}}，参数可选)
 * @return Promise
 */
export const $get = (url, params, headersObj) => {
  let axios_url = url in path ? path[url] : url
  let axios_obj = {}

  if (headersObj && params) {
    for (let key in headersObj) {
      axios_obj[key] = headersObj[key]
    }
    axios_obj.params = params
  }

  if (headersObj === undefined && params) {
    if ('headers' in params && Object.keys(params).length === 1) {
      axios_obj.headers = params.headers
    } else {
      axios_obj.headers = {
        Accept: 'application/json',
        // Authorization: ('tokenParam' in localStorage ) ? localStorage.getItem('tokenParam') : '',
        // Sign: ('signParam' in localStorage ) ? localStorage.getItem('signParam') : ''
      }
      axios_obj.params = params
    }
  }

  if (headersObj === undefined && params === undefined) {
    axios_obj.headers = {
      Accept: 'application/json',
      // Authorization: ('tokenParam' in localStorage ) ? localStorage.getItem('tokenParam') : '',
      // Sign: ('signParam' in localStorage ) ? localStorage.getItem('signParam') : ''
    }
  }

  return axios.get(axios_url, axios_obj).then(res => {
    if (res.data.constructor === Blob) {
      return Promise.resolve(res.data)
    } else {
      if (res.data.status === 1) {
        return Promise.resolve(res.data)
      } else {
        Message.error(res.data.msg)
        return Promise.reject(res.data)
      }
    }
  }).catch(err => {
    return Promise.reject(err)
  })

}

/**
 * http之post请求 (该方法已挂载Vue对象上，不必引入额外资源，直接通过this.$post(url,paramsObj,headersObj)的方式即可调用)
 * @param url (String类型，参数必填)
 * @param paramsObj (Object类型，参数可选)
 * @param headersObj (Object类型，有且有唯一键headers，例如：{headers：{"Accept": "application/json"}}，参数可选)
 * @return Promise
 */
export const $post = (url, paramsObj, headersObj) => {
  let axios_url = url in path ? path[url] : url
  let axios_paramsObj = {}
  let axios_headersObj = {}

  if (headersObj && paramsObj) {
    axios_headersObj = headersObj
    axios_paramsObj = paramsObj
  }

  if (headersObj === undefined && paramsObj) {
    if ('headers' in paramsObj && Object.keys(paramsObj).length === 1) {
      axios_headersObj = paramsObj
    } else {
      axios_headersObj = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          // 'Authorization': ('tokenParam' in localStorage ) ? localStorage.getItem('tokenParam') : '',
          // 'Sign': ('signParam' in localStorage ) ? localStorage.getItem('signParam') : ''
        }
      }
      axios_paramsObj = paramsObj
    }
  }
  axios_headersObj.headers = Object.assign({}, {
    "Content-Type": "application/x-www-form-urlencoded",
    // 'Authorization': ('tokenParam' in localStorage ) ? localStorage.getItem('tokenParam') : '',
    // 'Sign': ('signParam' in localStorage ) ? localStorage.getItem('signParam') : ''
  }, axios_headersObj.headers);

  return axios.post(axios_url, qs.stringify(axios_paramsObj, { arrayFormat: 'repeat' }), axios_headersObj).then(res => {
    if (res.data.constructor === Blob) {
      return Promise.resolve(res.data)
    } else {
      if (res.data.status === 1) {
        return Promise.resolve(res.data)
      } else {
        Message.error(res.data.msg)
        return Promise.reject(res.data)
      }
    }
  }).catch(err => {
    return Promise.reject(err)
  })

}
/**
 * http请求 (该方法已挂载Vue对象上，不必引入额外资源，直接通过this.$http(type,url,paramsObj,headersObj)的方式即可调用)
 * @param type (请求方式 String类型，参数必填)
 * @param url (请求路径 String类型，参数必填)
 * @param queryObj (请求参数query Object类型，参数可选)//拼接在url后面
 * @param paramsObj (请求参数body Object类型，参数可选)//requestbody中的参数
 * @param headersObj (请求头 Object类型，有且有唯一键headers，例如：{headers：{"Accept": "application/json"}}，参数可选)
 * @return Promise
 */
export const $query = (type, url, querysObj, paramsObj, headersObj) => {
  let axios_url = url in path ? path[url] : url
  let axios_obj = {}
  let axios_paramsObj = {}
  let axios_headersObj = {}
  let axios_querysObj = {}
  axios_headersObj = headersObj
  axios_paramsObj = paramsObj
  axios_querysObj = querysObj

  if (type == 'get') {
    axios_obj.headers = {
      Accept: 'application/json',
      Authorization: ('tokenParam' in localStorage) ? localStorage.getItem('tokenParam') : '',
      Sign: ('signParam' in localStorage) ? localStorage.getItem('signParam') : ''
    }
    axios_obj.params = paramsObj


    return axios.get(axios_url, axios_obj).then(res => {
      if (res.data.constructor === Blob) {
        return Promise.resolve(res.data)
      } else {
        if (res.data.status === 1) {
          return Promise.resolve(res.data)
        } else {
          Message.error(res.data.msg)
          return Promise.reject(res.data)
        }
      }
    }).catch(err => {
      return Promise.reject(err)
    })
  } else if (type == 'post') {
    axios_headersObj.headers = {
      ...axios_headersObj.headers,
      'Authorization': ('tokenParam' in localStorage) ? localStorage.getItem('tokenParam') : '',
      'Sign': ('signParam' in localStorage) ? localStorage.getItem('signParam') : ''
    }
    return axios.post(`${axios_url}?${qs.stringify(axios_querysObj)}`, JSON.stringify(axios_paramsObj), axios_headersObj).then(res => {
      if (res.data.constructor === Blob) {
        return Promise.resolve(res.data)
      } else {
        if (res.data.status === 1) {
          return Promise.resolve(res.data)
        } else {
          Message.error(res.data.msg)
          return Promise.reject(res.data)
        }
      }
    }).catch(err => {
      return Promise.reject(err)
    })
  }
}

export function checkLogin (data) {
  return fetch({
    url: '/init/checkLogin',
    method: 'post',
    data
  })
}

